module.exports = __webpack_public_path__ + "img/pinkdocument-icon.70f02530.svg";